export default class ApiExceptionError extends Error {
  name: string
  type: string
  constructor() {
    super('Something goes wrong! Try again later!')
    this.name = 'NeverHappensError'
    this.type = 'never-happens'
  }
}
